var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"sub-title",style:({
  'border-color': _vm.borderColor,
  'background-color': _vm.bgColor,
  'color': _vm.textColor,
  'font-size': _vm.fontSize,
  'border-style': _vm.borerStyle
})},[_vm._v("\n  "+_vm._s(_vm.title)+"\n")])}
var staticRenderFns = []

export { render, staticRenderFns }